import { useEffect, useState } from 'react';
import SheetModal from '@/components/General/SheetModal';
import Input from '@/components/General/inputs/Input';
import InputSection from '@/components/General/inputs/InputSection';
import Callout from '@/components/General/Callout';

/**
 * FollowUpReasonSheet — the shared reason-entry sheet for P6 audited
 * overrides (waive / pause / cancel / reopen — spec §12.6: explicit,
 * reasoned, audited). The confirm button stays disabled while a required
 * reason is empty so a silent no-reason override is impossible.
 */
const FollowUpReasonSheet = ({
    isOpen,
    onClose,
    title,
    subtitle,
    message,
    reasonLabel = 'Reason',
    reasonHelpText,
    reasonRequired = true,
    confirmText = 'Confirm',
    loading = false,
    onConfirm,
    testIDPrefix = 'follow-up-reason-sheet',
}) => {
    const [reason, setReason] = useState('');

    useEffect(() => {
        if (isOpen) setReason('');
    }, [isOpen]);

    const canConfirm = !reasonRequired || !!reason.trim();

    return (
        <SheetModal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            subtitle={subtitle}
            stayOpenOnBlur
            snapPoints={[320, 480]}
            loading={loading}
            cancelText="Cancel"
            confirmText={confirmText}
            onConfirm={canConfirm ? () => onConfirm?.(reason.trim()) : null}
        >
            <InputSection>
                {!!message && <Callout type="info" message={message} />}
                <Input
                    title={`${reasonLabel}${reasonRequired ? '' : ' (optional)'}`}
                    helpText={reasonHelpText}
                    required={reasonRequired}
                    value={reason}
                    onUpdate={setReason}
                    testID={`${testIDPrefix}-reason`}
                />
            </InputSection>
        </SheetModal>
    );
};

export default FollowUpReasonSheet;
